import { create } from 'zustand'

interface ModalState {
   isLeadDetailsModalOpen: boolean
   campaignName: string | null
   statType: 'source' | 'campaign' | null
   openLeadDetailsModal: (campaignName: string, statType: 'source' | 'campaign') => void
   closeLeadDetailsModal: () => void
}

export const useLeadDetailsModalStore = create<ModalState>((set) => ({
   isLeadDetailsModalOpen: false,
   statType: null,
   campaignName: null,
   openLeadDetailsModal: (campaignName, statType) =>
      set({ isLeadDetailsModalOpen: true, campaignName, statType }),
   closeLeadDetailsModal: () =>
      set({
         isLeadDetailsModalOpen: false,
         statType: null,
         campaignName: null,
      }),
}))
